import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialog: {
      minWidth: 500,
    },

    groupLabel: {
      color: theme.palette.text.primary,
      fontWeight: 'bold',
      justifyContent: 'center',
      display: 'flex',
      margin: '10px 0px',
    },
  }),
);
export default useStyles;
